import styled from 'styled-components';

export const ServicesContainer = styled.div`
    width: 100vw;
    height: 100vh; /* Just for demonstration, adjust as needed */
    max-height: 100vh;
    overflow-y: auto;

    .main-container {
        width: 100%;
        height: auto;
        background-color: rgba(000, 000, 000, 0.5);
        display: flex;
        flex-direction: column;
        transition: 0.45s;
        transition-timing-function: linear;
        position: relative;
        overflow-x: hidden;
        // overflow-y: auto;

        .options-container {
            width: 200%;
            height: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            left: -100%;
            transition-timing-function: linear;


            .services-main {
                width: 100vw;
                height: max-content;
                display: flex;
                flex-direction: column;
                
            }

            .space{
                // background-color: red;
                width: 100vw;
            }
        }

        

        // .lil-header {
        // 	width: 100%;
        // 	height: 20px;
        // }
    }
`;